<template>
  <button
    type="button"
    class="r-button"
    :class="[
      buttonStyle ? 'r-button--' + buttonStyle : '',
      outline ? 'r-button--' + buttonStyle + '--outline' : '',
      {
        'r-button--round': round,
        'r-button--full': full,
        'r-button--icon': icon,
        'r-button--middle': middle,
        'r-button--small': small,
        'r-button--disabled': disabled,
      },
    ]"
    :style="{
      'background-color': customColor,
      'border-color': customColor,
    }"
    @click="clickHandler"
    :disabled="disabled"
  >
    <i :class="['fa', 'fa-' + icon]" v-if="icon"></i>
    <slot></slot>
  </button>
</template>

<script>
import "focus-visible";

export default {
  name: "r-button",
  props: {
    buttonStyle: {
      type: String,
      default: "",
    },
    // fontawesome用
    icon: {
      type: String,
      default: "",
    },
    disabled: Boolean,
    round: Boolean,
    outline: Boolean,
    full: Boolean,
    middle: Boolean,
    small: Boolean,
    customColor: String,
  },
  methods: {
    clickHandler(e) {
      this.$emit("click", e);
    },
  },
};
</script>

<style scoped>
.r-button {
  border-radius: 5px;
  border: 2px solid;
  font-size: 1rem;
  font-weight: bold;
  background-color: #ffffff;
  appearance: none;
  outline: none;
  padding: 5px;
}
.r-button:focus:not(.focus-visible) {
  outline: none;
}
.r-button:hover {
  cursor: pointer;
}
/* buttonStyle */
.r-button--primary {
  background-color: #e87352;
  border-color: #e87352;
  color: #ffffff;
}
.r-button--secondary {
  background-color: #517ce8;
  border-color: #517ce8;
  color: #ffffff;
}
.r-button--secondary:hover {
  opacity: 0.7;
  transition: opacity 0.5s;
}
/* round */
.r-button--round {
  border-radius: 45px;
}
/* full */
.r-button--full {
  width: 100%;
}
.r-button--middle {
  width: 320px;
  height: 56px;
}
.r-button--small {
  width: 80px;
  height: 40px;
}

/* outline */
.r-button--primary--outline {
  background: #ffffff;
  color: #e87352;
}
.r-button--primary--outline:hover {
  background: #e87352;
  color: #ffffff;
  cursor: pointer;
  transition: 0.5s;
}
.r-button--secondary--outline {
  background: #ffffff;
  color: #517ce8;
}

.r-button--disabled {
  opacity: 0.7;
  pointer-events: none;
}
</style>
